import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface, } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_05_Interface, Empty_DataEntity_Detail_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Detail_05_Interface';
import { DataEntity_Main_05_Interface, Empty_DataEntity_Main_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Main_05_Interface';
import { DataEntity_Working_05_Interface, Empty_DataEntity_Working_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Working_05_Interface';
import { DataEntity_Resolution_05_Interface, Empty_DataEntity_Resolution_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Resolution_05_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity05Service } from 'src/app/Service/DataEntity/05/DataEntity05.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DataEntity05',
  templateUrl: './DataEntity05.component.html',
  styleUrls: ['./DataEntity05.component.css']
})
export class DataEntity05Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity05_Service: DataEntity05Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }
  FileName: string = '';
  FileName1: string = '';
  FolderName: string = '';
  MappingFile: string = '';
  Capability: string = '';

  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';


  Manufacture1_txt: String = '';
  Type1_txt: String = '';
  Model1_txt: String = '';
  Model2_txt: String = '';
  Code1_txt: String = '';
  Serial1_txt: String = '';

  Fororaftegi_txt: String = '';
  working_temp_min_txt: String = '';
  working_temp_max_txt: String = '';


  DataEntity_Id: number = 8;
  form_type: number = 1;

  range_nominal: string = ''
  range_nominal_unit: string = ''

  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;
  Calibration_Id: number = 0;
  Observation: number = 0;


  unit_setPoint: string = ''
  unit_reference: string = ''
  unit_indication: string = ''

  unit_instability: string = ''
  unit_inhomogeneity: string = ''
  unit_correction: string = ''

  unit_correction_eqution: string = ''
  unit_uncertainy: string = ''
  unit_working: string = ''



  ngOnInit() {

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),

      working_type: new FormControl("1", [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(''),
      range_min: new FormControl(''),
      scale: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity_Thermometer = new FormGroup({
      range_max: new FormControl(''),
      range_min: new FormControl(''),
      scale: new FormControl(null),
    });

    this.ResolutionFormDataEntity_Working = new FormGroup({
      value: new FormControl(null, [Validators.required]),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity05_Service.GetSingle(this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_05_Interface = Empty_DataEntity_Main_05_Interface();
          this.Observation = data['observation'];

          this.DataList_Resolution = data['resolution'];
          this.DataList_Resolution_01 = data['resolution_01'];


          this.DataList_Resolution_Thermometer = data['thermostat'];
          this.DataList_Resolution_Working = data['working'];
          this.form_type = data['form_type'];

          this.range_nominal = temp.range_nominal
          this.range_nominal_unit = temp.range_nominal_unit


          this.Nominal_Value_List = []
          this.Nominal_Value_List_01 = []

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FileName1 = temp.filename1;
          this.FolderName = temp.pdf_src;
          this.MappingFile = temp.pdf_src;
          this.Capability = temp.capability;

          this.unit_setPoint = temp.unit_setPoint;
          this.unit_reference = temp.unit_reference;
          this.unit_indication = temp.unit_indication;

          this.unit_instability = temp.unit_instability;
          this.unit_inhomogeneity = temp.unit_inhomogeneity;
          this.unit_correction = temp.unit_correction;


          this.unit_correction_eqution = temp.unit_correction_eqution;
          this.unit_uncertainy = temp.unit_uncertainty;
          this.unit_working = temp.unit_working;





          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          this.Manufacture1_txt = temp.manufacture1;
          this.Type1_txt = temp.type1;
          this.Model1_txt = temp.model1;
          this.Model2_txt = temp.model2;
          this.Code1_txt = temp.code1;
          this.Serial1_txt = temp.serial1;

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);

          this.get_Form_Working_type().setValue(temp['working_type']);

          for (let item of data['detail']) {
            var tempDetail: DataEntity_Detail_05_Interface = Empty_DataEntity_Detail_05_Interface();

            tempDetail.indication = item['indication'];
            tempDetail.reference = item['reference'];
            tempDetail.correction = item['correction'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.converage = item['converage'];
            tempDetail.status = item['status'];


            tempDetail.before = item['before'];

            if (item.status == 1)
              this.Nominal_Value_List.push(tempDetail);
            else
              this.Nominal_Value_List_01.push(tempDetail);
          }
        }
        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  //#region Main Data Entity

  Nominal_Value_List: Array<DataEntity_Detail_05_Interface> = [];
  Nominal_Value_List_01: Array<DataEntity_Detail_05_Interface> = [];
  temp_Nominal_Value_List: Array<DataEntity_Detail_05_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }
  get_Form_Working_type() {
    return this.MainFormDataEntity.get('working_type') as FormControl;
  }


  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files, status) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity05_Service.uploadFile(formData).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {

          if (status == 1) {
            this.Nominal_Value_List = []
            this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

            this.FileName = data['filename']
            this.Capability = data['capability']

            for (let item of data['nominal']) {
              var temp: DataEntity_Detail_05_Interface = Empty_DataEntity_Detail_05_Interface()

              temp.indication = item['indication']
              temp.reference = item['reference']
              temp.correction = item['correction']
              temp.uncertainty = item['uncertainty']
              temp.converage = item['converage']
              temp.status = 1
              this.Nominal_Value_List.push(temp)

            }
          }
          else {
            this.Nominal_Value_List_01 = []
            this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

            this.FileName1 = data['filename']
            this.Capability = data['capability']

            for (let item of data['nominal']) {
              var temp: DataEntity_Detail_05_Interface = Empty_DataEntity_Detail_05_Interface()

              temp.indication = item['indication']
              temp.reference = item['reference']
              temp.correction = item['correction']
              temp.uncertainty = item['uncertainty']
              temp.converage = item['converage']
              temp.status = 2
              this.Nominal_Value_List_01.push(temp)

            }
          }

        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity05_Service.uploadPdf(formData).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['filename']) {
          this.Alerify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Unit
  modalRef_Unit: any
  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Selected_Unit: string = ''

  OnUserSetUnit(index: Number, template: TemplateRef<any>) {
    if (!this.unit_indication && index != 1)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_reference && index != 2)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_correction && index != 3)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_correction_eqution && index != 4)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_uncertainy && index != 5)
      this.Set_Selected_Unit(index, template)
    else if (!this.unit_working && index != 6)
      this.Set_Selected_Unit(index, template)
  }

  Set_Selected_Unit(index: Number, template: TemplateRef<any>) {
    if (index == 1)
      this.Selected_Unit = this.unit_indication
    else if (index == 2)
      this.Selected_Unit = this.unit_reference
    else if (index == 3)
      this.Selected_Unit = this.unit_correction
    else if (index == 4)
      this.Selected_Unit = this.unit_correction_eqution
    else if (index == 5)
      this.Selected_Unit = this.unit_uncertainy
    else if (index == 6)
      this.Selected_Unit = this.unit_working

    if (this.Selected_Unit)
      this.modalRef_Unit = this.modalService.show(template);
  }

  SetToAllUnit() {
    if (!this.unit_indication)
      this.unit_indication = this.Selected_Unit

    if (!this.unit_reference)
      this.unit_reference = this.Selected_Unit

    if (!this.unit_correction)
      this.unit_correction = this.Selected_Unit

    if (!this.unit_correction_eqution)
      this.unit_correction_eqution = this.Selected_Unit

    if (!this.unit_uncertainy)
      this.unit_uncertainy = this.Selected_Unit

    if (!this.unit_working)
      this.unit_working = this.Selected_Unit

    this.modalRef_Unit.hide()
  }

  //#endregion

  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input: Calibration_Interface) {
    this.Calibration_Device = input
  }

  //#endregion

  //#region Resolution Thermostat
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_05_Interface> = []
  DataList_Resolution_01: Array<DataEntity_Resolution_05_Interface> = []
  temp_DataList_Resolution: Array<DataEntity_Resolution_05_Interface> = []

  Delete_Resolution(id: number, status: number) {
    if (status == 1)
      this.DataList_Resolution.splice(id, 1)
    else
      this.DataList_Resolution_01.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution(status: number) {

    var temp_DataList_Resolution: Array<DataEntity_Resolution_05_Interface> = []
    if (1 == status) {
      temp_DataList_Resolution = this.DataList_Resolution
    }
    else {
      temp_DataList_Resolution = this.DataList_Resolution_01
    }

    var CanAdd: Boolean = true
    for (let item of temp_DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_range_min().value) && Number(this.get_Form_range_min().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_range_max().value) && Number(this.get_Form_range_max().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
    }

    if (temp_DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("حداکثر ۷ مورد رنج و رزلوشن می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_05_Interface = Empty_DataEntity_Resolution_05_Interface()
      temp.range_min = this.get_Form_range_min().value + ''
      temp.range_max = this.get_Form_range_max().value + ''
      temp.scale = this.get_Form_scale().value + ''
      temp.status = status

      if (status == 1)
        this.DataList_Resolution.push(temp)
      else
        this.DataList_Resolution_01.push(temp)

      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_range_min() {
    return this.ResolutionFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.ResolutionFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_scale() {
    return this.ResolutionFormDataEntity.get('scale') as FormControl;
  }

  //#endregion

  //#region Resolution Thermometer
  ResolutionFormDataEntity_Thermometer: FormGroup;
  DataList_Resolution_Thermometer: Array<DataEntity_Resolution_05_Interface> = []
  DataList_Resolution_Thermometer_01: Array<DataEntity_Resolution_05_Interface> = []

  Delete_Resolution_Thermometer(id: number, status: number) {
    if (status == 1)
      this.DataList_Resolution_Thermometer.splice(id, 1)
    else
      this.DataList_Resolution_Thermometer_01.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution_Thermometer(status: number) {

    var temp_DataList_Resolution: Array<DataEntity_Resolution_05_Interface> = []
    if (1 == status) {
      temp_DataList_Resolution = this.DataList_Resolution_Thermometer
    }
    else {
      temp_DataList_Resolution = this.DataList_Resolution_Thermometer_01
    }

    var CanAdd: Boolean = true
    for (let item of temp_DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_Thermometer_range_min().value) && Number(this.get_Form_Thermometer_range_min().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_Thermometer_range_max().value) && Number(this.get_Form_Thermometer_range_max().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
    }

    if (temp_DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("حداکثر ۷ مورد رنج و رزلوشن می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_05_Interface = Empty_DataEntity_Resolution_05_Interface()
      temp.range_min = this.get_Form_Thermometer_range_min().value + ''
      temp.range_max = this.get_Form_Thermometer_range_max().value + ''
      temp.scale = this.get_Form_Thermometer_scale().value + ''
      temp.status = status
      if (status == 1)
        this.DataList_Resolution_Thermometer.push(temp)
      else
        this.DataList_Resolution_Thermometer_01.push(temp)
      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_Thermometer_range_min() {
    return this.ResolutionFormDataEntity_Thermometer.get('range_min') as FormControl;
  }

  get_Form_Thermometer_range_max() {
    return this.ResolutionFormDataEntity_Thermometer.get('range_max') as FormControl;
  }

  get_Form_Thermometer_scale() {
    return this.ResolutionFormDataEntity_Thermometer.get('scale') as FormControl;
  }

  //#endregion

  //#region Resolution Working
  ResolutionFormDataEntity_Working: FormGroup;
  DataList_Resolution_Working: Array<DataEntity_Working_05_Interface> = []

  Delete_Resolution_Working(id: number) {
    this.DataList_Resolution_Working.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution_Working() {

    var CanAdd: Boolean = true
    for (let item of this.DataList_Resolution_Working) {
      if (Number(item.value) == Number(this.get_Form_Working_value().value)) {
        CanAdd = false
        break;
      }

    }

    if (this.DataList_Resolution_Working.length >= 70) {
      this.Alerify_Service.ErrorMessage("حداکثر 70 مورد working می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Working_05_Interface = Empty_DataEntity_Working_05_Interface()
      temp.value = this.get_Form_Working_value().value + ''
      this.DataList_Resolution_Working.push(temp)
      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_Working_value() {
    return this.ResolutionFormDataEntity_Working.get('value') as FormControl;
  }


  //#endregion

  //#region Before

  Add_Before(index: number, status: number) {
    var Temp_Total_Nominal_Value_List: Array<DataEntity_Detail_05_Interface> = [];

    if (status == 1)
      Temp_Total_Nominal_Value_List = this.Nominal_Value_List
    else
      Temp_Total_Nominal_Value_List = this.Nominal_Value_List_01

    if ((Temp_Total_Nominal_Value_List.length) > index + 1 && Temp_Total_Nominal_Value_List[index + 1].before == true) {
      this.Alerify_Service.ErrorMessage("کپی به عنوان before انجام شده است.")
    }
    else {

      var Temp_Nominal_Value_List: Array<DataEntity_Detail_05_Interface> = [];

      for (let item of Temp_Total_Nominal_Value_List) {

        if (Temp_Total_Nominal_Value_List.indexOf(item) != index) {
          Temp_Nominal_Value_List.push(item);
        }
        else {
          Temp_Nominal_Value_List.push(item);

          var tempDetail: DataEntity_Detail_05_Interface = Empty_DataEntity_Detail_05_Interface();

          tempDetail.indication = item.indication;
          tempDetail.reference = item.reference;
          tempDetail.correction = item.correction;
          tempDetail.uncertainty = item.uncertainty;
          tempDetail.converage = item.converage;
          tempDetail.before = true;
          tempDetail.status = status

          Temp_Nominal_Value_List.push(tempDetail);
        }
      }

      if (status == 1)
        this.Nominal_Value_List = Temp_Nominal_Value_List
      else
        this.Nominal_Value_List_01 = Temp_Nominal_Value_List


    }
  }

  Delete_Before(index: number, status: number) {
    if (status == 1)
      this.Nominal_Value_List.splice(index, 1)
    else
      this.Nominal_Value_List_01.splice(index, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input: string) {
    this.Calibration_Device.labAdderss = input

  }

  //#endregion

  modalRef_CodeSerial: any;
  modalRef_CodeSerial_Title: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((!this.Calibration_Device.device_serial || !this.Calibration_Device.device_code || this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار سریال یا کد دستگاه  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Code1_txt || !this.Serial1_txt || this.Code1_txt.trim() == "" || this.Serial1_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار سریال یا کد دستگاه سنسور ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Manufacture1_txt || this.Manufacture1_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MANUFACTURE سنسور ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Type1_txt || this.Type1_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار TYPE سنسور ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Model_txt || this.Model_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MODEL  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Model1_txt || this.Model1_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MODEL سنسور 2 ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Model2_txt || this.Model2_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MODEL سنسور 1 ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if (this.DataList_Resolution_Working.length < 1 && this.form_type == 2) {
      this.Alerify_Service.ErrorMessage("حداقل یک مقدار working وارد نمائید.")
    }
    else if (this.Model1_txt && this.DataList_Resolution.length != this.DataList_Resolution_01.length) {
      this.Alerify_Service.ErrorMessage("تعداد Range / Resolution هر دو فرم یکی نمی باشد")
    }
    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_05_Interface = Empty_DataEntity_Main_05_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_setPoint = this.unit_setPoint;
      temp.unit_reference = this.unit_reference;
      temp.unit_indication = this.unit_indication;

      temp.unit_instability = this.unit_instability;
      temp.unit_inhomogeneity = this.unit_inhomogeneity;
      temp.unit_correction = this.unit_correction;

      temp.unit_correction_eqution = this.unit_correction_eqution;
      temp.unit_uncertainty = this.unit_uncertainy;
      temp.unit_working = this.unit_working;


      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;
      temp.working_type = Number(this.get_Form_Working_type().value)


      temp.manufacture1 = this.Manufacture1_txt + '';
      temp.type1 = this.Type1_txt + '';
      temp.model1 = this.Model1_txt + '';
      temp.model2 = this.Model2_txt + '';
      temp.code1 = this.Code1_txt + '';
      temp.serial1 = this.Serial1_txt + '';


      temp.range_nominal = this.range_nominal;
      temp.range_nominal_unit = this.range_nominal_unit;


      this.temp_DataList_Resolution = []
      for (let item of this.DataList_Resolution_01) {
        this.temp_DataList_Resolution.push(item)
      }

      for (let item of this.DataList_Resolution) {
        this.temp_DataList_Resolution.push(item)
      }

      this.temp_Nominal_Value_List = []
      for (let item of this.Nominal_Value_List) {
        this.temp_Nominal_Value_List.push(item)
      }

      for (let item of this.Nominal_Value_List_01) {
        this.temp_Nominal_Value_List.push(item)
      }

      this.DataEntity05_Service.Submit(
        temp,
        this.temp_Nominal_Value_List,
        this.temp_DataList_Resolution,
        this.DataList_Resolution_Thermometer,
        this.DataList_Resolution_Working,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FileName1,
        this.FolderName,
        this.Capability,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss,
        0,
        this.Fororaftegi_txt,
        this.working_temp_min_txt,
        this.working_temp_max_txt).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('خطا سیستمی');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');

          this.OnIntial()

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });

    }
  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }


}
